module.exports = __webpack_public_path__ + "static/media/icon_instagram.05473f86.svg";